import React from 'react';
import { Box, Button, Typography } from '@mui/material';
import { Clear, ArrowBackAlt } from '@/static';
import { type DrawerContentProps } from '../../../state';
import styles from './styles';

type Props = {
  children: React.ReactNode;
  danger?: boolean;
  title: string;
  closeDrawer: DrawerContentProps['closeDrawer'];
  onAccept?: () => void;
  acceptText?: string;
  acceptDisabled?: boolean;
  onCancel?: () => void;
  cancelText?: string;
  onBack?: () => void;
  backText?: string;
};

const DrawerLayout = ({
  children,
  danger = false,
  title,
  closeDrawer,
  onAccept,
  acceptText = 'OK',
  acceptDisabled = false,
  onCancel,
  cancelText = 'Cancel',
  onBack,
  backText = 'Back',
}: Props) => (
  <Box sx={styles.wrapper}>
    <Box sx={styles.header}>
      <Typography sx={styles.title}>{title}</Typography>
    </Box>

    {onBack && (
      <Box sx={styles.backBtnWrapper}>
        <Button
          startIcon={<ArrowBackAlt />}
          variant="text"
          onClick={onBack}
          size="small"
        >
          {backText}
        </Button>
      </Box>
    )}

    <Box sx={styles.closeIconBtnWrapper}>
      <Button
        endIcon={<Clear />}
        variant="text"
        onClick={closeDrawer}
        size="small"
      >
        Close
      </Button>
    </Box>

    <Box sx={styles.body}>{children}</Box>

    {(onAccept || onCancel) && (
      <Box sx={styles.actions}>
        {onCancel && (
          <Button
            size="small"
            color="primary"
            variant="outlined"
            onClick={onCancel}
          >
            {cancelText}
          </Button>
        )}

        {onAccept && (
          <Button
            size="small"
            color={danger ? 'error' : 'primary'}
            variant="mainBtn"
            onClick={onAccept}
            disabled={acceptDisabled}
          >
            {acceptText}
          </Button>
        )}
      </Box>
    )}
  </Box>
);

export default DrawerLayout;
